export enum UsersPermissions {
  VIEW_USERS_MANAGEMENT = "view_users_management",
  CREATE_USERS_MANAGEMENT = "create_users_management",
  UPDATE_USERS_MANAGEMENT = "update_users_management",
  DELETE_USERS_MANAGEMENT = "delete_users_management",
  APPROVE_REJECT_USERS_MANAGEMENT = "approve_reject_users_management",
  ARCHIVE_USERS_MANAGEMENT = "archive_users_management",
  SEND_USERS_MANAGEMENT = "send_users_management",
}

export const UsersPermissionsText: Record<UsersPermissions, string> = {
  [UsersPermissions.VIEW_USERS_MANAGEMENT]: "View Users Management",
  [UsersPermissions.CREATE_USERS_MANAGEMENT]: "Create Users Management",
  [UsersPermissions.UPDATE_USERS_MANAGEMENT]: "Update Users Management",
  [UsersPermissions.DELETE_USERS_MANAGEMENT]: "Delete Users Management",
  [UsersPermissions.APPROVE_REJECT_USERS_MANAGEMENT]:
    "Approve/Reject Users Management",
  [UsersPermissions.ARCHIVE_USERS_MANAGEMENT]: "Archive Users Management",
  [UsersPermissions.SEND_USERS_MANAGEMENT]: "Send Users Management",
};
